import styled from 'styled-components';

export const ListAdminWrapper = styled.div`
  .ant-spin-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .ant-pagination .ant-pagination-total-text {
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ModalCreateUserWrapper = styled.div``;
